import { gql } from '@apollo/client';

export const DELETE_LEASING_INTEREST_TYPE_DETAIL = gql`
  mutation deleteLeasingInterestTypeDetail($interestTypeDetailId: Int!) {
    deleteLeasingInterestTypeDetail(interestTypeDetailId: $interestTypeDetailId) {
      commandId
      correlationId
    }
  }
`;
